const navbar = () => {
  $(() => {
    $("body").on("click", ".menu-item .material-symbols-outlined", function () {
      $(this).next(".dropdown-menu").toggleClass("d-none");
    });

    if ($(window).width() > 990) {
      $("body").on("mouseenter", ".dropdown", function () {
        $(this).find(".dropdown-menu").removeClass("d-none");
      });
      $("body").on("mouseleave", ".dropdown", function () {
        $(this).find(".dropdown-menu").addClass("d-none");
      });
    }


    window.addEventListener("scroll", () => {
      var scroll = $(window).scrollTop();
      var header_top = $(".header-top").outerHeight();

      if (scroll > header_top) {
        $("body").addClass("stickyHeader");
      } else {
        $("body").removeClass("stickyHeader");
      }
    });
  });
};

export default navbar;
